import styled from 'styled-components';

export const Wrapper = styled.main`
  display: flex;
  background: #f0fbff;
  width: 100vw;
  height: 100vh;
`;
